import React, { useMemo } from "react";
import { Field } from "react-final-form";
import { DropzoneInput } from "../../../components/inputs/final_form/DropzoneInput";
import { SftpSettingModal } from "./SftpSettingsModal";

export const EditSftpSettingModal = ({ resourceId, resourcePath, sftp, onEdit, showDocumentIngestion }) => {
  const inputAttributes = useMemo(
    () => ({
      component: DropzoneInput,
      hint: "Drop Keyfile",
      initialValue: sftp.keyfile_uploaded ? [{ name: "Keyfile provided" }] : undefined,
    }),
    [sftp.keyfile_uploaded]
  );

  return (
    <SftpSettingModal
      resourceId={resourceId}
      resourcePath={resourcePath}
      onAction={onEdit}
      sftp={sftp}
      toggleButtonLabel="Edit"
      toggleButtonProps={{ color: "link" }}
      actionTitle="Edit"
      showDocumentIngestion={showDocumentIngestion}
      keyfileInput={<Field accept={null} label="Keyfile" name="keyfile" {...inputAttributes} />}
    />
  );
};
